import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.post('/masterdata-api/user/page', params)

// 新增或更新
export const updateAndAdd = params =>
  request.post('/masterdata-api/user/add', params)

// 获取 role list
export const getRoleList = () => request.get('/masterdata-api/role/list')

// 获取 business role list
export const getBusinessRoleList = () =>
  request.get('/masterdata-api/business-role/list')

// 激活用户
export const activationUser = id =>
  request.get(`/masterdata-api/user/unfrozen/${id}`)

// 冻结用户
export const freezeUser = id => request.get(`/masterdata-api/user/frozen/${id}`)
